<!-- Icons for Laptop/iPad View -->
<div style="margin: 0 10px;">
   <div class="d-flex justify-content-between align-items-center flex-wrap w-100" appCheckFlexWrap
      (flexWrapped)="onWrapChange($event)" [class.du-header-nowrap]="chartName === 'customKPICard'">
      <ng-container *ngFor="let hdr of headerConfig;let i = index;">
         <ng-container *ngIf="hdr.add_header">

            <!-- Header -->
            <div *ngIf="hdr.header_name_isNeed" [id]="sanitizeId(heading)" class="du-header-title"
               style="font-weight: 600;font-family: poppins; line-height: 24px;font-size: 1.2em;display: block;margin-left: 7px;">
               <div id="du-full-headername" #fullHeaderName [matTooltip]="fullHeaderName.innerText"
                  [matTooltipDisabled]="chartName !== 'customKPICard' || !isTextClipped(fullHeaderName)">

                  <span *ngIf="chartType=='child'" (click)="chartBack($event)"
                     style="padding: 0 10px 0 0;cursor: pointer;">
                     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                           d="M6.15459 9.30647L16 9.30647V6.10166L6.15459 6.10165L9.98015 2.27609L7.70406 0L0 7.70406L7.70406 15.4081L9.98015 13.132L6.15459 9.30647Z"
                           fill="#1363DF" />
                     </svg>
                  </span>

                  <span
                     *ngIf="hdr.sp_nm_visibility && filterService.baseQuery?.[hdr.sp_nm_visibility_key] && (hdr.sp_nm_visibility_key != 'from_date' || hdr.sp_nm_visibility_key != 'to_date')"
                     style="margin-right: 5px;">
                     {{ this.findWhichKey(hdr.sp_nm_visibility_key, hdr.firstValue) + ", " }}
                  </span>

                  <span
                     *ngIf="hdr.sp_nm_visibility && filterService.baseQuery?.[hdr.sp_nm_visibility_key] && (hdr.sp_nm_visibility_key == 'from_date' || hdr.sp_nm_visibility_key == 'to_date')"
                     style="margin-right: 5px;">
                     {{ this.findPrefixDateFormat(hdr) }}
                  </span>
                  <span style="padding-right:0px;" *ngIf="hdr.nav_header && hdr.nav_header_align!='right'"> {{
                     nav_header_name}}&nbsp;</span>

                  {{ filterService.baseQuery?.source_nm && sourceHeaderName ? hdr.page_header_name +' '+(
                  (filterService.showByHeader=='true') ? (filterService.showByKey=='N'?'NDC':'Location'):'') :
                  replacePlaceholders(hdr.page_header_name) +' '+( (filterService.showByHeader=='true')?
                  (filterService.showByKey=='N'?'NDC':'Location'):'') }}

                  <span
                     *ngIf="hdr?.spb_nm_visibility && filterService.baseQuery?.[hdr.spb_nm_visibility_key] && (hdr.sp_nm_visibility_key != 'from_date' && hdr.sp_nm_visibility_key != 'to_date' && hdr.spb_nm_visibility_key != 'from_date' && hdr.spb_nm_visibility_key != 'to_date') && hdr.spb_nm_visibility_key != 'patient_status'"
                     style="margin-left: 5px;">
                     <span *ngIf="cardId=='single'">{{ " "+ this.findWhichKey(hdr.spb_nm_visibility_key,
                        hdr.secondValue) }}</span>
                     <span *ngIf="cardId=='single' && this.getLocation()">{{", " + this.getLocation()}}</span>
                     <span *ngIf="cardId=='single' && this.getXAxisValue()">{{", " + this.getXAxisValue()}}</span>

                     <span *ngIf="cardId!='single'" style="color: #1363DF;white-space: normal;"> {{ " - "+
                        this.findWhichKey(hdr.spb_nm_visibility_key, hdr.secondValue) }}</span>

                     <span *ngIf="cardId!='single' && findFlagKey(hdr.spb_nm_visibility_key, hdr)">
                        <span class="du-decomm-btn" matTooltip="Decommissioned" style="padding: 2px 10px;margin: 0 5px;">Decomm.</span>
                     </span>

                     <span *ngIf="cardId!='single'">{{" - Q"+ moment(filterService.baseQuery?.['from_date']).quarter()+'
                        '+moment(filterService.baseQuery?.['from_date']).year()}}</span>

                     <span *ngIf="cardId!='single' && this.detailData.length>0">
                        {{ ' - ' }}
                        <span *ngFor="let a of detailData;let last = last;let idx = index;">

                           <span>{{ (a.filterKey == 'date' ? moment(a[a.key]).format("MM/DD/YYYY") : a[a.key]) }}</span>

                           <span *ngIf="!last">{{ ' - ' }}</span>
                        </span>
                     </span>
                  </span>

                  <span style="padding-right:0px;" *ngIf="hdr.nav_header && hdr.nav_header_align=='right'"> {{ '- ' +
                     nav_header_name }}&nbsp;</span>

                  <span
                     *ngIf="hdr.spb_nm_visibility && filterService.baseQuery?.[hdr.spb_nm_visibility_key] && (hdr.spb_nm_visibility_key == 'from_date' || hdr.spb_nm_visibility_key == 'to_date')"
                     style="margin-left: 5px;">
                     {{ this.findSuffixDateFormat(hdr) }}
                  </span>

                  <span
                     *ngIf="hdr.spb_nm_visibility && filterService.baseQuery?.[hdr.spb_nm_visibility_key] && hdr.spb_nm_visibility_key == 'patient_status'"
                     style="margin-left: 5px;">
                     <span *ngIf="cardId!='single'" style="color: #1363DF;white-space: normal;"> {{ " - "+
                        this.findWhichKey(hdr.spb_nm_visibility_key, hdr.secondValue) }}</span>

                  </span>

                  <span *ngIf="hdr.data_count == true" style="color: #8A98AB;margin: 0 0 0 5px;">
                     <span *ngIf="hdr.data_count == true" style="color: #8A98AB;margin: 0 0 0 5px;">
                        <span>{{ rowDataCount ? ( '(' + this.numberPipe.transform(rowDataCount) + ')') : '(' +
                           (rowDataLength?.length ? rowDataLength.length : 0) + ')' }} </span>
                     </span>
                  </span>

                  <span *ngIf="selectedHeader" style="color: #8A98AB;margin: 0 0 0 5px;">
                     <span>{{ '- ' + selectedHeader }} </span>
                  </span>

                  <span *ngIf="chartName === 'DataCorrectionGrid'" style="display: inline-flex; align-items: center; gap: 8px; margin-left: 10px;">
                     <!-- ERROR legend — click to show/hide error defect columns -->
                     <span
                        matTooltip="Click to show only Error columns"
                        (click)="toggleErrorColumns.emit()"
                        [style.background]="showErrorColumns ? '#FDECC8' : '#F3F4F6'"
                        [style.border-color]="showErrorColumns ? '#F59E0B' : '#E5E7EB'"
                        [style.font-weight]="showErrorColumns ? '600' : '500'"
                        style="cursor: pointer; user-select: none; display: inline-flex; align-items: center; gap: 4px; font-size: 11px; color: #374151; border: 1px solid #E5E7EB; border-radius: 20px; padding: 3px 12px; transition: all 0.2s ease;">
                        <span style="width: 9px; height: 9px; border-radius: 50%; background: #F59E0B; display: inline-block; flex-shrink: 0;"></span>
                        ERROR
                        <span *ngIf="errorCount !== null && errorCount !== undefined"
                           style="background: #fff; border-radius: 8px; padding: 0 5px; margin-left: 2px; font-size: 10px; line-height: 15px; font-weight: 600; color: #F59E0B;">{{ errorCount }}</span>
                     </span>
                     <!-- FAIL legend — click to show/hide fail defect columns -->
                     <span
                        matTooltip="Click to show only Fail columns"
                        (click)="toggleFailColumns.emit()"
                        [style.background]="showFailColumns ? '#FBD5D0' : '#F3F4F6'"
                        [style.border-color]="showFailColumns ? '#E74C3C' : '#E5E7EB'"
                        [style.font-weight]="showFailColumns ? '600' : '500'"
                        style="cursor: pointer; user-select: none; display: inline-flex; align-items: center; gap: 4px; font-size: 11px; color: #374151; border: 1px solid #E5E7EB; border-radius: 20px; padding: 3px 12px; transition: all 0.2s ease;">
                        <span style="width: 9px; height: 9px; border-radius: 50%; background: #E74C3C; display: inline-block; flex-shrink: 0;"></span>
                        FAIL
                        <span *ngIf="failCount !== null && failCount !== undefined"
                           style="background: #fff; border-radius: 8px; padding: 0 5px; margin-left: 2px; font-size: 10px; line-height: 15px; font-weight: 600; color: #E74C3C;">{{ failCount }}</span>
                     </span>
                  </span>

               </div>
               <div *ngIf="hdr?.page_subheader_name"
                  style="font-weight: 500;font-family: poppins; line-height: 14px;font-size: 14px;display: block;color: #8A98AB;">
                  <span>{{replacePlaceholders(hdr.page_subheader_name)}}</span>
               </div>
            </div>

            <!-- Annotations -->
            <span *ngIf="hdr.value=='annotation'&& annotations">
               <div style="width: 152px; height: 32px;border-radius: 4px;background-color: #D0E0F9;">
                  <div style="padding:5px">
                     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_8824_9006)">
                           <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M12.2644 15.1879L12.1655 15.4694C12.1062 15.638 11.9213 15.7277 11.7522 15.6699L10.3414 15.1879H12.2644ZM11.9843 0.350104C12.6739 0.519917 13.0952 1.21657 12.9254 1.90614C12.7609 2.57382 12.1025 2.99004 11.4349 2.86157L11.1903 3.37857H15.0655C15.2452 3.37857 15.3917 3.52514 15.3917 3.70482V14.2091C15.3917 14.3888 15.2452 14.5354 15.0655 14.5354H4.72972C4.55003 14.5354 4.40347 14.3888 4.40347 14.2091V3.70482C4.40347 3.52514 4.55003 3.37857 4.72972 3.37857H10.47L10.8473 2.58135C10.4859 2.27585 10.3075 1.78176 10.4283 1.29117C10.5981 0.601604 11.2947 0.180292 11.9843 0.350104ZM11.1903 3.37857H10.47L9.51009 5.40707C9.43337 5.56967 9.503 5.76367 9.66556 5.84039C9.82816 5.9171 10.0222 5.84748 10.0989 5.68492L11.1903 3.37857ZM6.81759 12.0876H12.9776C13.1578 12.0876 13.3038 11.9415 13.3038 11.7614C13.3038 11.5812 13.1578 11.4351 12.9776 11.4351H6.81759C6.63741 11.4351 6.49134 11.5812 6.49134 11.7614C6.49134 11.9415 6.63744 12.0876 6.81759 12.0876ZM6.81759 9.75492H12.9776C13.1578 9.75492 13.3038 9.60885 13.3038 9.42867C13.3038 9.24848 13.1578 9.10242 12.9776 9.10242H6.81759C6.63741 9.10242 6.49134 9.24848 6.49134 9.42867C6.49134 9.60885 6.63744 9.75492 6.81759 9.75492ZM6.81759 7.42226H12.9776C13.1578 7.42226 13.3038 7.2762 13.3038 7.09601C13.3038 6.91582 13.1578 6.76976 12.9776 6.76976H6.81759C6.63741 6.76976 6.49134 6.91582 6.49134 7.09601C6.49134 7.2762 6.63744 7.42226 6.81759 7.42226ZM3.75097 12.936V3.70482C3.75097 3.16501 4.18991 2.72607 4.72972 2.72607H8.21741L4.33497 1.43182C4.1645 1.37501 3.97912 1.4677 3.92228 1.63817L0.626124 11.526C0.569562 11.6957 0.660905 11.8801 0.830124 11.9379L3.75097 12.936Z"
                              fill="#1363DF" />
                        </g>
                        <defs>
                           <clipPath id="clip0_8824_9006">
                              <rect width="16" height="16" fill="white" />
                           </clipPath>
                        </defs>
                     </svg>
                     <span style="font-family: Poppins;font-weight: 600;font-size: 12px;"> Annotations mode x</span>
                  </div>
               </div>
            </span>

            <span *ngIf="hdr.value=='range_bar' && (selectedMapConfig?.mode == 'state-badge' || selectedMapConfig?.mode == 'state-icon')">
               <app-range-h-bar
                  [data]="data"
                  [selectedMapConfig]="selectedMapConfig"
                  (hoverValueChange)="onRangeBarHover($event)"
                  >
               </app-range-h-bar>
            </span>
            <span *ngIf="hdr.value=='legends_territory_map' && (selectedMapConfig?.mode == 'state-cone' || selectedMapConfig?.mode == 'state-bubble')">
               <app-legend-label [colorTypes]="selectedMapConfig?.colorTypes" [config]="hdr" (legendToggle)="togglePracticeTypes($event)"></app-legend-label>
            </span>

            <!-- Search Box Laptop -->
            <span *ngIf="hdr.value=='search_box'" class="d-flex align-items: center" style="position: relative;">

               <div class="input-group" *ngIf="hdr.server_side_search_box" style="flex-wrap: nowrap;">
                  <div class="input-group-text cls-du-height-search" id="btnGroupAddon">
                     <select class="du-header-search-dropdown" [(ngModel)]="selectedSearchByKey"
                        (change)="findSearchBySelectedName(selectedSearchByKey,hdr)">
                        <option *ngFor="let data of searchByKey;" [value]="data.value">{{data.name}}</option>
                     </select>
                  </div>
                  <input type="search" class="form-control du-header-search-input cls-du-height-search"
                     [(ngModel)]="serverSideSearchFilterText" [placeholder]="'Search by '+ searchBySelectedName.name"
                     aria-label="Search by" aria-describedby="btnGroupAddon" (keydown.enter)="serverSideSearch(hdr)"
                     (input)="serverSideSearchClose($event,hdr)">
                  <div class="input-group-text cls-du-height-search" id="btnGroupAddon">
                     <span class="mat-search-box-du" (click)="serverSideSearch(hdr)">
                        <svg width="13" height="13" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path
                              d="M6.33333 11.6667C9.27885 11.6667 11.6667 9.27885 11.6667 6.33333C11.6667 3.38781 9.27885 1 6.33333 1C3.38781 1 1 3.38781 1 6.33333C1 9.27885 3.38781 11.6667 6.33333 11.6667Z"
                              stroke="#101d42" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                           <path d="M10.3333 10.334L13 13.0007" stroke="#101d42" stroke-width="1.5"
                              stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                     </span>
                  </div>
               </div>

               <span *ngIf="!hdr.server_side_search_box">
                  <input type="search" class="form-control" [style.width.px]="300"
                     style="border: 1px solid #ddd;border-radius: 5px;font-family: 'Poppins';font-size: 12px;padding: 0 10px"
                     id="filter-text-box" [placeholder]="'Type to Search'" autocomplete="off"
                     (input)="onQuickFilterChanged($event)" [(ngModel)]="clientSideSearchFilterText">
               </span>
            </span>

            <!-- Legends Laptop -->
            <span *ngIf="hdr.value=='legends'" class="d-flex align-items-center du-legends-header mx-2">
               <div *ngFor="let legend of hdr.legends_data;" class="mx-2">
                  <div class="d-flex align-items-center" style="white-space: nowrap;">
                     <span class="mx-2"><mat-icon style="height: 20px;width: 20px;overflow: visible;"
                           [svgIcon]="legend.icon"></mat-icon></span>
                     <span class="du-legends-icons-chart">{{ legend.name }}</span>
                  </div>
               </div>
            </span>

            <!-- Follow Up Laptop -->
            <span *ngIf="hdr.value=='follow_up'" style="display: flex;align-items: center;cursor: pointer;">
               <mat-icon (click)="followUP()" style="width: 12px;margin-right: 5px;" [svgIcon]="plus"></mat-icon>
               <span (click)="followUP()" style="color: #1363DF">Create follow up</span>
            </span>

            <!-- Selection Toggle (Bar) Laptop -->
            <span class="widContainers" *ngIf="hdr.value == 'selection_toggle'">
               <div class="d-flex justify-content-between">
                  <button *ngFor="let item of hdr['toggle_btn'];" (click)="changeDisplayType(item.value, hdr)"
                     [ngClass]="{'highlight': selectedType===item.value}" class="cycleHover">
                     {{ item.title + findSelectedTypeCount(item.value, hdr) }}
                  </button>
               </div>
            </span>
            <!-- <span *ngIf="hdr.value == 'selection_toggle'" class="mt-1" style="text-align: left !important;">
                  <div style="display:flex; align-items:center; gap: 5px;">
                     <span class="headS">Analytical Mode</span>
                     <mat-slide-toggle class="togControl" style="float: right;"></mat-slide-toggle>
                  </div>
            </span> -->

            <!-- Moving Avg Laptop -->
            <span class="widgets-container" *ngIf="hdr.value == 'moving_average'">
               <div class="d-flex">
                  <div class="iconPads" style="margin-top: -4px;padding-right: 2px;">
                     <mat-icon [svgIcon]="settingsm" style="padding: 3px 6px 3px 3px;cursor: pointer;"
                        id="moving_average" (click)="selectedVal()" [closeOnOutsideClick]="false" mwlConfirmationPopover
                        [customTemplate]="customTemplate" placement="bottom">
                     </mat-icon>
                  </div>

                  <div class="iconPads">
                     <span style="color: #8A98AB;">
                        Moving Average Periods:
                     </span>

                     <span style="margin-left: 6px;">{{counter}}</span>
                  </div>
               </div>
            </span>

            <!-- Time Cycle Laptop -->
            <span *ngIf="hdr.value == 'time_cycle'">
               <div class="d-flex justify-content-between" class="widget-container-timeCycle">
                  <div *ngFor="let item of hdr.timeValues" (click)="changeTimeCycleEvent($event,item.value)"
                     [ngClass]="{'highlightTimeCycle': selectedTypeTimeCyle===item.value}" class="cycleHoverTimeCycle">
                     {{item.value}}
                  </div>
               </div>
            </span>

            <!-- Network Header Status Label Laptop -->
            <span *ngIf="hdr.value == 'status_label'" class="d-flex w-max-content pipeline_sort">
               <div class="d-flex align-items-center pipeline_sort_icon ml-2"
                  *ngFor="let item of selectedFilter.values">
                  <mat-icon [style.color]="item.color">circle</mat-icon>
                  <span class="option_value" style="flex: none !important;">{{item.name}}</span>
               </div>
            </span>

            <!-- ShowBy Laptop -->
            <span *ngIf="hdr.value == 'sort_by'" class="d-flex dropdown_val align-items-center"
               style="width: max-content;">

               <div class="d-flex bd-highlight justify-content-between ml-1 align-items-center sort_by_styles">
                  <div class="bd-highlight">
                     <label for="sortBy" class="sort_by_text mt-2">Show By |</label>
                  </div>
                  <div class="ms-auto bd-highlight">
                     <select class="sort_by_select text-center" id="sortBy" name="Select"
                        (change)="sortByChange($event)">
                        <option *ngFor="let data of sortByArray" [value]="data['dropdownName']" class="dropdown_values">
                           {{data['dropdownName']}}</option>
                     </select>
                  </div>
               </div>

               <!-- <div class="sort_by_styles ml-2" style="flex:inherit">
                  <label for="sortBy" class="sort_by_text mt-2">Show By |</label>
                  <select class="sort_by_select text-center" id="sortBy" name="Select" (change)="sortByChange($event)">
                     <option *ngFor="let data of sortByArray" [value]="data['dropdownName']" class="dropdown_values">
                        {{data['dropdownName']}}</option>
                  </select>
               </div> -->
            </span>

            <div *ngIf="hdr.value == 'show_by'" class="showByContainer align-items-center w-auto"
               style="text-align: center;">
               <div class="sort_by_styles d-flex" style="width: 210px;">
                  <label for="sortBy" class="sort_by_texts mt-2" style="border-right: 2px solid  #E8EAEE;">{{
                     hdr?.show_by_label ? hdr?.show_by_label : 'Show By' }}&nbsp;&nbsp;</label>
                  <mat-select class="sort_by_select text-center" panelClass="show-by-panel" hideSingleSelectionIndicator
                     [matTooltip]="tooltipForShowBy(hdr.show_by_value,showByvalue)" [(ngModel)]="showByvalue"
                     (ngModelChange)="showByChange($event)">
                     <mat-option *ngFor="let showBy of hdr.show_by_value" [value]="showBy.value"
                        class="dropdown_values">{{showBy.title}}</mat-option>
                  </mat-select>
               </div>
            </div>
            
            <div *ngIf="hdr.value == 'map_show_by'" class="showByContainer align-items-center w-auto"
               style="text-align: center;">
               <div class="sort_by_styles d-flex" style="width: 210px;">
                  <label for="sortBy" class="sort_by_texts mt-2" style="border-right: 2px solid  #E8EAEE;">{{
                     hdr?.map_show_by_label ? hdr?.map_show_by_label : 'Show By' }}&nbsp;&nbsp;</label>
                  <mat-select class="sort_by_select text-center" panelClass="show-by-panel" hideSingleSelectionIndicator
                     [matTooltip]="tooltipForMapShowBy(mapDesignerConfig,selectedMapShowBy)" [(ngModel)]="selectedMapShowBy"
                     (ngModelChange)="showByMapChange($event)">
                     <mat-option *ngFor="let showBy of mapDesignerConfig;" [value]="showBy.id"
                        class="dropdown_values">{{showBy.label}}</mat-option>
                  </mat-select>
               </div>
            </div>
            
            <!-- Page Size Laptop -->
            <span *ngIf="hdr.value == 'page_size'" style="white-space: nowrap;">
               <span>Page Size</span> &nbsp;
               <input type="number" noENotationInput [min]="minValue" [max]="maxValue"
                  (keydown.enter)="onPageSizeChanged()" [(ngModel)]="paginationPageSize" [ngStyle]="{
                     width: chartName == 'PixelMapDiv' ? '60px' : '50px',
                     'border-radius': '0.2rem',
                     border: '2px solid #E8EAEE',
                     'margin-right': '10px',
                     'text-align': 'center'
                  }">
               <button class="btn btn-primary btn-sm rounded-circle" (click)="onPageSizeChanged()"
                  style="width: 30px;height: 30px;text-align: center;margin: 0 !important;padding: 0 !important;"
                  type="button" [disabled]="!inputPagenationFromDir">Go</button>
            </span>

            <!-- PHI Toggle Button Laptop -->
            <span *ngIf="hdr.hidden_toggle && (rowDataLength?.length > 0 || rowDataCount > 0) && hasPhiHiddenToggle"
               style="white-space: nowrap;">
               <span style="font-weight: 600; font-size: 14px;font-family: poppins;line-height: 18px;padding: 0 15px;">
                  {{ hdr.hidden_toggle_name || "PHI Column" }}
               </span>

               <mat-slide-toggle color="primary" [checked]="this.phiChecked"
                  (change)="isPHIFunc(hdr)"></mat-slide-toggle>
            </span>

            <span *ngIf="hdr.analytical_mode" style="white-space: nowrap;">
               <span style="font-weight: 600; font-size: 14px;font-family: poppins;line-height: 18px;padding: 0 15px;">
                  {{ hdr.analytical_mode_name }}
               </span>

               <mat-slide-toggle color="primary" [checked]="this.pixelMapRef.useAnalyticalMode"
                  (change)="setAnalyticalMode($event.checked)"></mat-slide-toggle>
            </span>

            <!-- Alerts Laptop -->
            <span *ngIf="hdr.value == 'alerts'">
               <app-alert-icons-commom class="ml-2 mr-2" [alertIcons]="alertIcons"></app-alert-icons-commom>
            </span>

            <!-- Thumb Slider Laptop -->
            <span *ngIf="hdr.slider" style="white-space: nowrap;">

               <span style="font-weight: 500;color: #8A98AB;font-size: 14px;font-family: poppins;line-height: 18px">
                  {{ hdr.slider_name || 'Activity since days' }} :
               </span>

               <span style="color: #101D42;font-weight: 700; padding: 0 7px;">
                  {{ this.sliderValue }}
               </span>

               <!-- TODO: The 'tickInterval' property no longer exists -->
               <mat-slider #gridsize style="width: 150px;" step="1"
                  [min]="hdr.slider_custom_range ? hdr.sliderLenth[0].min : 1"
                  [max]="hdr.slider_custom_range ? hdr.sliderLenth[0].max : 7" [(ngModel)]="this.sliderValue" #ngSlider><input matSliderThumb (change)="updateSetting({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" />
               </mat-slider>

            </span>

            <!-- Right side Icon -->
            <span *ngIf="hdr.icon_selected" style="display:flex">

               <!-- <span *ngIf="this.deviceDetectionService.isTablet">
                  <mat-icon type="button" [matMenuTriggerFor]="iPadMode" class="matIcons"
                     svgIcon="setting_responsive"></mat-icon>
                  <mat-icon type="button" class="matIcons" svgIcon="vr_line_ipad"></mat-icon>
               </span> -->
               <span *ngFor="let icon of hdr.iconList">
                  <span *ngIf="icon.activated">
                     <mat-icon matTooltip="Export List" class="matIcons" [svgIcon]="'dotmenu_circle_disabled'"
                        *ngIf="annotations&&icon.name=='dotmenu_circle'"></mat-icon>
                     <mat-icon matTooltip="Export List" class="matIcons" [svgIcon]="icon.name"
                        *ngIf="!annotations&&icon.name=='dotmenu_circle'" [matMenuTriggerFor]="Exportmenu"
                        (menuOpened)="prepareCopyImage(icon)"></mat-icon>

                     <mat-menu #Exportmenu="matMenu" class="chart-export-menu">
                        <span *ngFor="let ic of icon?.event">
                           <a *ngIf="ic.is_true==true && !((ic.value == 'png' || ic.value == 'copy_image') && phiChecked)" mat-menu-item
                              style="font-family: 'Poppins'!important;"
                              (click)="ic.value == 'pdf' || ic.value == 'pdftable' ? openPDFcustom(ic.value) : ic.value == 'excel' || ic.value == 'csv' ? excelExport() : ic.value == 'png' ? exportToPNG() : ic.value == 'copy_image' ? copyImageToClipboard() : excelExportAPI()">
                              <mat-icon
                                 [svgIcon]="ic.value == 'pdf' || ic.value == 'pdftable'? 'pdf' : ic.value == 'excel' ? 'xls' : ic.value == 'csv' ? 'csv': ic.value == 'png' || ic.value == 'copy_image' ? 'png': 'xls'"></mat-icon>{{ic.dispPlayName}}</a>
                        </span>
                     </mat-menu>
                     <mat-icon matTooltip="Sort" class="matIcons" [svgIcon]="icon.name"
                        *ngIf="icon.name =='sort' && ((this.dashboardKey == 20241125043213 || this.dashboardKey == 20241008125650) ? this.historyFlag=='H' : true)"
                        (click)="triggerSorts($event)"></mat-icon>
                     <mat-icon matTooltip="Help" class="matIcons"
                        [svgIcon]="annotations?'info_circle_disabled':icon.name" *ngIf="icon.name =='info_circle'"
                        [matMenuTriggerFor]="annotations?null:info"
                        (click)="annotations?'':getInfoDetail(icon)"></mat-icon>

                     <mat-icon matTooltip="Select" class="matIcons" [svgIcon]="icon.name"
                        *ngIf="icon.name =='select_setting'" [matMenuTriggerFor]="dimensionsMenu"
                        (click)="dimensionsData(hdr,icon)" (menuClosed)="onMenuClose()"></mat-icon>

                     <mat-icon [matTooltip]=" isFullscreen ? ' Exit Full Screen': 'Show Full Screen'" class="matIcons"
                        [svgIcon]=" isFullscreen ? 'collapse_arrow':icon.name " *ngIf="icon.name =='expand_circle'"
                        (click)="isFullscreen ? closeFullscreen() : openFullscreen()"></mat-icon>
                     <mat-icon matTooltip="Change Status" class="matIcons" [svgIcon]="icon.name"
                        *ngIf="icon.name =='change_status'" (click)="changeStatus()"></mat-icon>
                     <mat-icon matTooltip="Show Underlying Data" class="matIcons"
                        [svgIcon]="annotations?'tabular_circle_disabled':icon.name" *ngIf="icon.name =='tabular_circle'"
                        (click)="annotations?'':openDialog()"></mat-icon>
                     <mat-icon matTooltip="User Union" class="matIcons" [svgIcon]="icon.name"
                        *ngIf="icon.name =='union_circle'"></mat-icon>
                     <mat-icon class="compareIconsBtn" svgIcon="compareBtn"
                        *ngIf="compareChart && icon.name =='compare'" (click)="CompareBtn()"></mat-icon>
                     <mat-icon class="manageStatusBtn" svgIcon="manage_statusBtn" *ngIf="icon.name =='manage_statusBtn'"
                        (click)="manageStatus()"></mat-icon>
                     <mat-icon [matTooltip]="  compareChart ?' ':'Compare'"
                        [class]="compareChart ?'compareIcons': 'matIcons'"
                        [svgIcon]=" compareChart ?'compareCross': icon.name" *ngIf="icon.name =='compare'"
                        (click)="Compare()"></mat-icon>
                     <mat-icon matTooltip="Setting" class="matIcons" [svgIcon]="icon.name" *ngIf="icon.name =='setting'"
                        (click)="openPreferencesScreen()"></mat-icon>

                     <!-- <mat-icon matTooltip="Settings" class="matIcons" [svgIcon]="'preference_settings'"
                        *ngIf="icon?.name === 'preference_settings'"
                        mwlConfirmationPopover [(isOpen)]="ispreferencesOpen" (click)="isPrefOpen()"
                        [closeOnOutsideClick]="false" [customTemplate]="preferenceTemplate" placement="bottom-right">
                     </mat-icon> -->
                     <mat-icon #settingsTrigger matTooltip="Settings" class="matIcons"
                        *ngIf="icon?.name === 'preference_settings'" [svgIcon]="'preference_settings'"
                        (click)="openPreferences($event)"></mat-icon>


                     <mat-icon matTooltip="Settings" class="matIcons" id="setting" [svgIcon]="'shuffle_disabled'"
                        *ngIf="icon.name =='shuffle'&& annotations"></mat-icon>

                     <mat-icon matTooltip="Settings" class="matIcons" id="setting" [svgIcon]="icon.name"
                        *ngIf="icon.name =='shuffle'&&!annotations" mwlConfirmationPopover [(isOpen)]="isPopoverOpen"
                        (click)="PopoverOpen()" [closeOnOutsideClick]="false"
                        [customTemplate]="chartName === 'PixelMapDiv' ? SettingTemplatePixelMap : 
                        chartName === 'ChordChartDiv' ? SettingTemplateChordChart : 
                        SettingTemplate"
                        placement="bottom"></mat-icon>
                     <mat-icon matTooltip="Transaction Details" class="matIcons" [svgIcon]="'layout_disabled'"
                        *ngIf="icon.name =='layout'&& annotations"></mat-icon>
                     <mat-icon matTooltip="Transaction Details" class="matIcons" [svgIcon]="icon.name"
                        *ngIf="icon.name =='layout'&& !annotations" (click)="controlChartPopup(icon)"></mat-icon>
                     <mat-icon matTooltip="Notes" class="matIcons" [svgIcon]="icon.name"
                        *ngIf="icon.name =='notes_circle'"></mat-icon>
                     <mat-icon matTooltip="Annotations" class="matIcons"
                        [svgIcon]="annotations?'annotations_cross':'annotations'" *ngIf="icon.name =='notes'"
                        (click)="annotationmethod()"></mat-icon>

                     <!-- <mat-icon matTooltip="Settings" id="setting" class="matIcons" [svgIcon]="icon.name" *ngIf="icon.name =='setting'"
                        mwlConfirmationPopover [customTemplate]="SettingTemplate" placement="bottom"></mat-icon> -->
                     <mat-icon matTooltip="Expand All" class="matIcons" [svgIcon]="icon.name"
                        *ngIf="icon.name =='gridload_circle' && !expandChart" (click)="expandCollapse()"></mat-icon>
                     <mat-icon matTooltip="Collapse All" class="matIcons" svgIcon="collapse_new"
                        *ngIf="icon.name =='gridload_circle' && expandChart" (click)="expandCollapse()"></mat-icon>
                     <mat-icon [svgIcon]="expandCollapseIcon" class="matIcons" *ngIf="icon.name =='expand'"
                        (click)="pivotexpandCollapse()" [matTooltip]="expandOrCollapse"></mat-icon>
                     <!-- [svgIcon]="expandCollapseIcon" -->
                  </span>
               </span>
            </span>
         </ng-container>
      </ng-container>
   </div>
</div>

<!-- <mat-menu #setting="matMenu">
   <div mat-subheader
      style="background-color: #e8e8e8;margin: 3px;border-radius: 8px 8px 0px 0px;padding: 10px;margin: 2px;"> Table
      view</div>
   <div style="margin: 10px; cursor: pointer;" (click)="this.pivotGrid.showByValue('source')"> By SP </div>
   <div style="margin: 10px; cursor: pointer;" (click)="this.pivotGrid.showByValue('NDC')"> By NDCs </div>
</mat-menu> -->

<ng-template #preferenceTemplate>
   <div class="settings-popover" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
      cdkDragBoundary=".cdk-overlay-container">

      <!-- Header -->
      <div class="settings-header">
         <div class="settings-header-left">
            <span style="width: 20px;height:20px;">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path
                  d="M7.82924 16.1426L8.31628 17.238C8.46106 17.564 8.69734 17.8411 8.99647 18.0355C9.29559 18.23 9.6447 18.3334 10.0015 18.3334C10.3582 18.3334 10.7073 18.23 11.0065 18.0355C11.3056 17.8411 11.5419 17.564 11.6866 17.238L12.1737 16.1426C12.3471 15.7539 12.6387 15.4299 13.007 15.2167C13.3777 15.0029 13.8065 14.9118 14.232 14.9565L15.4237 15.0834C15.7784 15.1209 16.1364 15.0547 16.4543 14.8928C16.7721 14.7309 17.0362 14.4803 17.2144 14.1713C17.3929 13.8625 17.4779 13.5086 17.4592 13.1524C17.4405 12.7963 17.3188 12.4532 17.1089 12.1648L16.4033 11.1954C16.1521 10.8476 16.0178 10.429 16.02 10C16.0199 9.57218 16.1554 9.15531 16.407 8.80928L17.1126 7.83984C17.3225 7.55148 17.4442 7.20841 17.4629 6.85225C17.4816 6.49608 17.3966 6.14214 17.2181 5.83335C17.0399 5.52438 16.7758 5.27376 16.458 5.11188C16.1401 4.94999 15.7821 4.8838 15.4274 4.92132L14.2357 5.04817C13.8102 5.09286 13.3814 5.00179 13.0107 4.78798C12.6417 4.57356 12.35 4.24782 12.1774 3.85743L11.6866 2.76206C11.5419 2.436 11.3056 2.15895 11.0065 1.96452C10.7073 1.77009 10.3582 1.66663 10.0015 1.66669C9.6447 1.66663 9.29559 1.77009 8.99647 1.96452C8.69734 2.15895 8.46106 2.436 8.31628 2.76206L7.82924 3.85743C7.65668 4.24782 7.36497 4.57356 6.99591 4.78798C6.62526 5.00179 6.19647 5.09286 5.77091 5.04817L4.57554 4.92132C4.22081 4.8838 3.86282 4.94999 3.54497 5.11188C3.22711 5.27376 2.96305 5.52438 2.7848 5.83335C2.60632 6.14214 2.52128 6.49608 2.54002 6.85225C2.55876 7.20841 2.68046 7.55148 2.89035 7.83984L3.59591 8.80928C3.84753 9.15531 3.98302 9.57218 3.98295 10C3.98302 10.4279 3.84753 10.8447 3.59591 11.1908L2.89035 12.1602C2.68046 12.4486 2.55876 12.7916 2.54002 13.1478C2.52128 13.504 2.60632 13.8579 2.7848 14.1667C2.96323 14.4755 3.22732 14.726 3.54513 14.8878C3.86294 15.0497 4.22084 15.116 4.57554 15.0787L5.76721 14.9519C6.19276 14.9072 6.62155 14.9983 6.99221 15.2121C7.36265 15.4259 7.65571 15.7517 7.82924 16.1426Z"
                  stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
               <path
                  d="M9.99998 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61931 11.3807 7.50002 9.99998 7.50002C8.61926 7.50002 7.49998 8.61931 7.49998 10C7.49998 11.3807 8.61926 12.5 9.99998 12.5Z"
                  stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg></span>
            <span class="settings-title">{{heading ||"Settings"}}</span>
             <button
               mat-icon-button
               class="settings-close-btn"
               aria-label="Close"
               (click)="closePreferences()"
            >
               <mat-icon mat-dialog-close class="close-icon" style="color: rgba(138, 152, 171, 1);">close</mat-icon>
            </button>
         </div>
      </div>

      <!-- Content -->
      <div class="settings-body">
         <app-chart-preferences-formly #prefForm [item]="item" [chartPrefConfig]="chartPrefConfig"
            (preferencesChange)="applyChartPreferences($event)">
         </app-chart-preferences-formly>
      </div>

      <!-- Footer -->
      <div class="settings-footer">
         <button type="button" matTooltip="Preview" class="prefre btn apply-btn"
            (click)="previewPreferences($event)">Preview</button>
         <button type="button" matTooltip="Reset to Default" class="prefre btn reset-btn"
            (click)="resetPreferences(item)">Reset</button>
         <button type="button" matTooltip="Cancel" class="prefre btn cancel-btn"
            (click)="prefrecancel()">Cancel</button>
         <button type="button" matTooltip="Apply" class="prefre btn apply-btn"
            (click)="applyPreferences($event)">Apply</button>
      </div>

   </div>
</ng-template>


<mat-menu #setting="matMenu">
   <!-- <div mat-subheader
				style="background-color: #e8e8e8;margin: 3px;border-radius: 8px 8px 0px 0px;padding: 10px;margin: 2px;">
				Table view
			</div>
			<div style="margin: 10px; cursor: pointer;" (click)="this.pivotGrid.showByValue('source')"> By SP </div>
			<div style="margin: 10px; cursor: pointer;" (click)="this.pivotGrid.showByValue('NDC')"> By NDCs </div> -->
   <div style="margin: 10px; cursor: pointer;" (click)="openPreferencesScreen()"> Preferences </div>
</mat-menu>



<mat-menu #dimensionsMenu="matMenu" class="dimensions-menu" xPosition="before" yPosition="below" [hasBackdrop]="true"
   (menuOpened)="onMenuOpen()">

   <!-- Header -->
   <div class="menu-header" (click)="$event.stopPropagation()">Dimensions</div>

   <!-- Debug button (remove in production) -->
   <!-- <button (click)="debugState()">Debug</button> -->

   <!-- Select / Deselect All -->
   <div class="menu-item" (click)="$event.stopPropagation()"
      style="font-size: 12px; border-bottom: 1px solid #E8EAEE;padding-top: 8px;margin-bottom: 8px;">
      <mat-checkbox [checked]="isAllSelected()" (change)="toggleAll($event.checked)">
         Select/Deselect All
      </mat-checkbox>
   </div>
   <!-- Dynamic options -->
   <div class="menu-item" *ngFor="let dim of dimensions; let i = index" (click)="$event.stopPropagation()">
      <mat-checkbox [(ngModel)]="dim.selected" (change)="onChange()">
         {{ dim.value }}
      </mat-checkbox>
   </div>
   <hr *ngIf="totalPercentageConstant">
   <!-- Toggle for Show Total Triaged -->
   <div *ngIf="totalPercentageConstant" style="padding: 5px 10px 7px 10px;display: flex;gap: 18px;align-items: anchor-center;"
      (click)="$event.stopPropagation()">

      <span style="font-size: 14px; margin-left: 2px; color: #101D42; font-family: poppins;"
         (click)="$event.stopPropagation()">
         Show (%) by Total Triaged
      </span>

      <mat-slide-toggle class="	triage-toggle" [(ngModel)]="showTotalTriaged" (change)="toggleTriaged($event)">
      </mat-slide-toggle>


   </div>
   <hr>

   <!-- Footer -->
   <div class="menu-footer">
      <button type="button" matTooltip="Close" class="prefre btn cancel-btn" (click)="onMenuClose()">Cancel</button>
      <button type="button" matTooltip="Apply" class="prefre btn apply-btn" [disabled]="isApplyDisabled"
         (click)="applySelection()">Apply</button>
   </div>
</mat-menu>

<ng-template #dialogTemplate let-data="data">

   <div class="deletePopup" style="font-family: Poppins;">
      <div class="d-flex justify-content-between align-items-center" style="background-color: #F6F8FB;">
         <div class="p-2">
            <span style="font-size: 15px;font-weight: 600;">{{item?.config['report_heading'] || 'Options'}}</span>
         </div>
         <div class="p-2" style="margin: 0 0 -5px 0px !important;">
            <mat-icon mat-dialog-close class="close-icon" style="color: rgba(138, 152, 171, 1);">close</mat-icon>
         </div>
      </div>

      <div mat-dialog-content class="matDialogg">
         <div class="row">
            <div class="col-12" *ngFor="let icon of iconList1">
               <div class="d-flex" style="align-items:center;">
                  <div class="d-flex flex-column" *ngIf="icon.name =='Slider'">
                     <div class="mr-2">
                        <span
                           style="font-weight: 500;color: #8A98AB;font-size: 14px;font-family: poppins;line-height: 18px">Activity
                           since(days):
                        </span>
                     </div>
                     <div class="d-flex justify-content-between align-items-center">
                        <span style="color: #101D42;font-weight: 700; padding: 0 7px;">{{
                           sliderValue}}</span>

                        <!-- TODO: The 'tickInterval' property no longer exists -->
                        <mat-slider #gridsize style="width: 210px;" step="1"
                           [min]="icon.slider_custom_range ? icon.sliderLenth[0].min : 1"
                           [max]="icon.slider_custom_range ? icon.sliderLenth[0].max : 7" #ngSlider><input matSliderThumb [(ngModel)]="this.sliderValue" (change)="updateSetting({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" />
                        </mat-slider>

                        <!-- <mat-slider class="mr-3" #gridsize (change)="updateSetting($event)" style="width: 210px;" step="1"
                                                   tickInterval="2" min="1" max="7" [(ngModel)]="this.sliderValue"></mat-slider> -->
                     </div>
                  </div>
                  <mat-icon class="matIcons" [svgIcon]="icon.name" *ngIf="icon.name =='info_circle' && icon.activated"
                     [matMenuTriggerFor]="info" (click)="getInfoDetail(icon)"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]=" isFullscreen ? 'collapse_arrow':icon.name "
                     *ngIf="icon.name =='expand_circle' && icon.activated"
                     (click)="isFullscreen ? closeFullscreen() : openFullscreen()"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]="icon.name"
                     *ngIf="icon.name =='tabular_circle' && icon.activated" (click)="openDialog()"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]="icon.name"
                     *ngIf="icon.name =='union_circle' && icon.activated"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]="icon.name" *ngIf="icon.name =='change_status' && icon.activated"
                     (click)="changeStatus()"></mat-icon>

                  <mat-icon [class]="compareChart ?'compareIcons': 'matIcons'"
                     [svgIcon]=" compareChart ?'compareCross': icon.name"
                     *ngIf="icon.name =='compare' && icon.activated" (click)="Compare()"></mat-icon>

                  <mat-icon matTooltip="Setting" id="setting" class="matIcons" [svgIcon]="icon.name"
                     *ngIf="icon.name =='setting'" (click)="openPreferencesScreen()"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]="icon.name"
                     *ngIf="icon.name =='gridload_circle' && !expandChart && icon.activated"
                     (click)="expandCollapse()"></mat-icon>

                  <mat-icon class="matIcons" svgIcon="collapse_new"
                     *ngIf="icon.name =='gridload_circle' && expandChart && icon.activated"
                     (click)="expandCollapse()"></mat-icon>

                  <mat-icon class="matIcons" svgIcon="pdf" (click)="openPDFcustom('pdf')"
                     *ngIf="icon.name=='PDF'"></mat-icon>

                  <mat-icon class="matIcons" svgIcon="xls" (click)="excelExport()"
                     *ngIf="icon.name=='Excel'"></mat-icon>

                  <mat-icon class="matIcons" svgIcon="csv" (click)="excelExport()" *ngIf="icon.name=='CSV'"></mat-icon>
                  <mat-icon class="matIcons" svgIcon="png" (click)="exportToPNG()"
                     *ngIf="icon.name=='PNG' && !phiChecked"></mat-icon>

                  <div class="ml-3 icon_description_resp" *ngIf="icon.name=='Excel'">Export as CSV</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name=='PDF'">Export as PDF</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name=='PNG' && !phiChecked">Export as PNG</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='info_circle' && icon.activated">
                     Information
                  </div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='change_status' && icon.activated">Change
                     Status</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='expand_circle' && icon.activated">
                     {{isFullscreen ?
                     'Exit Full Screen' : 'Full Screen'}}</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='tabular_circle' && icon.activated">Show
                     Underlying
                     Data</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='union_circle' && icon.activated">User View
                  </div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='compare' && icon.activated">Compare</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='setting' && icon.activated">Settings</div>
                  <div class="ml-3 icon_description_resp"
                     *ngIf="icon.name =='gridload_circle' && expandChart && icon.activated">
                     Collapse All</div>
                  <div class="ml-3 icon_description_resp"
                     *ngIf="icon.name =='gridload_circle' && !expandChart && icon.activated">
                     Expand All</div>
               </div>
               <hr style="border: 1px solid rgba(0, 0, 0, 0.05);" />
            </div>
         </div>
      </div>
   </div>
</ng-template>

<ng-template #SettingTemplatePixelMap>

   <div class="popoverCustom" cdkDrag cdkDragRootElement=".popoverCustom" cdkDragHandle
      cdkDragBoundary=".cdk-overlay-pane" [cdkDragFreeDragPosition]="{x: -80, y: 0}">
      <div class="header all-scroll " style="height: 40px;margin: -12px;border-radius: 5px;">
         <div class="row">
            <div class="col-6 text-start pl-2" style="margin: 8px 10px;">
               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                     d="M13.6057 7.37666L9.77561 7.37666V8.62341H13.6057L12.1175 10.1116L13.0029 10.9971L16 8.00004L13.0029 5.00297L12.1175 5.88842L13.6057 7.37666Z"
                     fill="#8A98AB" />
                  <path
                     d="M8.62521 6.22626L8.62334 2.39428L10.1116 3.88252L10.997 2.99707L7.99996 0L5.0029 2.99707L5.88835 3.88252L7.37659 2.39428L7.37659 6.22439L8.62521 6.22626Z"
                     fill="#8A98AB" />
                  <path
                     d="M7.37666 9.77561L7.37666 13.6057L5.88842 12.1175L5.00297 13.0029L8.00004 16L10.9971 13.0029L10.1116 12.1175L8.62341 13.6057L8.62528 9.77374L7.37666 9.77561Z"
                     fill="#8A98AB" />
                  <path
                     d="M3.88252 5.88835L2.99707 5.0029L0 7.99996L2.99707 10.997L3.88252 10.1116L2.39428 8.62334L6.22626 8.62521V7.37472L2.39428 7.37659L3.88252 5.88835Z"
                     fill="#8A98AB" />
               </svg>
            </div>
            <div class="col-3 text-end pt-1 justify-content-between contect" style="display: flex; margin: 0 24px;">
               <h3>Settings</h3>

            </div>
         </div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headS">Analytical Mode</span> <mat-slide-toggle class="togControl"
               [checked]="settingsInput.useAnalyticalMode" (change)="this.pixelMapRef.setAnalyticalMode()"
               style="float: right;"></mat-slide-toggle></div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headS">Lock to visible</span> <mat-slide-toggle class="togControl"
               [checked]="settingsInput.isLockedToVisible" (change)="this.pixelMapRef.toggleVisibleDataLock()"
               style="float: right;"></mat-slide-toggle></div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headS">Show Y axis</span> <mat-slide-toggle class="togControl"
               [checked]="settingsInput.showPatientIDs" (change)="this.pixelMapRef.togglePatientIDs()"
               style="float: right;"></mat-slide-toggle></div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headS">Extend blocks</span> <mat-slide-toggle class="togControl"
               [checked]="settingsInput.extendBlocks" (change)="this.pixelMapRef.toggleExtendBlocks()"
               style="float: right;"></mat-slide-toggle></div>
      </div>
      <div class="mt-3 mb-2" style="text-align: left !important;">
         <div>
            <span class="headSub">
            </span>
            <span class="text-left">
               <button type="button" class="btn btn-cancel" style="line-height: 15px;" (click)="cancel()">Close</button>
            </span>
            <span class="headSub" style="float: right;"><button type="button" class="btn  btn-reset"
                  (click)="reset()">Reset</button></span>
         </div>
      </div>
      <!-- </form> -->
   </div>
</ng-template>
<ng-template #SettingTemplateChordChart>

   <div class="popoverCustom" cdkDrag cdkDragRootElement=".popoverCustom" cdkDragHandle
      cdkDragBoundary=".cdk-overlay-pane" [cdkDragFreeDragPosition]="{x: -80, y: 0}">
      <div class="header all-scroll " style="height: 40px;margin: -12px;border-radius: 5px;">
         <div class="row">
            <div class="col-6 text-start pl-2" style="margin: 8px 10px;">
               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                     d="M13.6057 7.37666L9.77561 7.37666V8.62341H13.6057L12.1175 10.1116L13.0029 10.9971L16 8.00004L13.0029 5.00297L12.1175 5.88842L13.6057 7.37666Z"
                     fill="#8A98AB" />
                  <path
                     d="M8.62521 6.22626L8.62334 2.39428L10.1116 3.88252L10.997 2.99707L7.99996 0L5.0029 2.99707L5.88835 3.88252L7.37659 2.39428L7.37659 6.22439L8.62521 6.22626Z"
                     fill="#8A98AB" />
                  <path
                     d="M7.37666 9.77561L7.37666 13.6057L5.88842 12.1175L5.00297 13.0029L8.00004 16L10.9971 13.0029L10.1116 12.1175L8.62341 13.6057L8.62528 9.77374L7.37666 9.77561Z"
                     fill="#8A98AB" />
                  <path
                     d="M3.88252 5.88835L2.99707 5.0029L0 7.99996L2.99707 10.997L3.88252 10.1116L2.39428 8.62334L6.22626 8.62521V7.37472L2.39428 7.37659L3.88252 5.88835Z"
                     fill="#8A98AB" />
               </svg>
            </div>
            <div class="col-3 text-end pt-1 justify-content-between contect" style="display: flex; margin: 0 24px;">
               <h3>Settings</h3>

            </div>
         </div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headS">Toggle Labels</span> <mat-slide-toggle class="togControl"
               [checked]="settingsInput.showLabels" (change)="this.chordChartRef.toggleLabels()"
               style="float: right;"></mat-slide-toggle></div>
      </div>
      <div class="mt-3 mb-2" style="text-align: left !important;">
         <div>
            <span class="headSub">
            </span>
            <span class="text-left">
               <button type="button" class="btn btn-cancel" style="line-height: 15px;" (click)="cancel()">Close</button>
            </span>
            <span class="headSub" style="float: right;"><button type="button" class="btn  btn-reset"
                  (click)="reset()">Reset</button></span>
         </div>
      </div>
      <!-- </form> -->
   </div>
</ng-template>

<ng-template>
   <div class="deletePopup" style="font-family: Poppins;">
      <div class="d-flex justify-content-between align-items-center" style="background-color: #F6F8FB;">
         <div class="p-2">
            <span style="font-size: 15px;font-weight: 600;">{{item?.config['report_heading'] || 'Options'}}</span>
         </div>
         <div class="p-2" style="margin: 0 0 -5px 0px !important;">
            <mat-icon mat-dialog-close class="close-icon" style="color: rgba(138, 152, 171, 1);">close</mat-icon>
         </div>
      </div>

      <div mat-dialog-content class="matDialogg">
         <div class="row">
            <div class="col-12" *ngFor="let icon of iconList1">
               <div class="d-flex" style="align-items:center;">
                  <div class="d-flex flex-column" *ngIf="icon.name =='Slider'">
                     <div class="mr-2">
                        <span
                           style="font-weight: 500;color: #8A98AB;font-size: 14px;font-family: poppins;line-height: 18px">Activity
                           since(days):
                        </span>
                     </div>
                     <div class="d-flex justify-content-between align-items-center">
                        <span style="color: #101D42;font-weight: 700; padding: 0 7px;">{{
                           sliderValue}}</span>

                        <!-- TODO: The 'tickInterval' property no longer exists -->
                        <mat-slider #gridsize style="width: 210px;" step="1"
                           [min]="icon.slider_custom_range ? icon.sliderLenth[0].min : 1"
                           [max]="icon.slider_custom_range ? icon.sliderLenth[0].max : 7" #ngSlider><input matSliderThumb [(ngModel)]="this.sliderValue" (change)="updateSetting({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" />
                        </mat-slider>

                        <!-- <mat-slider class="mr-3" #gridsize (change)="updateSetting($event)" style="width: 210px;" step="1"
														tickInterval="2" min="1" max="7" [(ngModel)]="this.sliderValue"></mat-slider> -->
                     </div>
                  </div>
                  <mat-icon class="matIcons" [svgIcon]="icon.name" *ngIf="icon.name =='info_circle' && icon.activated"
                     [matMenuTriggerFor]="info" (click)="getInfoDetail(icon)"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]=" isFullscreen ? 'collapse_arrow':icon.name "
                     *ngIf="icon.name =='expand_circle' && icon.activated"
                     (click)="isFullscreen ? closeFullscreen() : openFullscreen()"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]="icon.name"
                     *ngIf="icon.name =='tabular_circle' && icon.activated" (click)="openDialog()"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]="icon.name"
                     *ngIf="icon.name =='union_circle' && icon.activated"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]="icon.name" *ngIf="icon.name =='change_status' && icon.activated"
                     (click)="changeStatus()"></mat-icon>

                  <mat-icon [class]="compareChart ?'compareIcons': 'matIcons'"
                     [svgIcon]=" compareChart ?'compareCross': icon.name"
                     *ngIf="icon.name =='compare' && icon.activated" (click)="Compare()"></mat-icon>

                  <mat-icon matTooltip="Setting" id="setting" class="matIcons" [svgIcon]="icon.name"
                     *ngIf="icon.name =='setting'" (click)="openPreferencesScreen()"></mat-icon>

                  <mat-icon class="matIcons" [svgIcon]="icon.name"
                     *ngIf="icon.name =='gridload_circle' && !expandChart && icon.activated"
                     (click)="expandCollapse()"></mat-icon>

                  <mat-icon class="matIcons" svgIcon="collapse_new"
                     *ngIf="icon.name =='gridload_circle' && expandChart && icon.activated"
                     (click)="expandCollapse()"></mat-icon>

                  <mat-icon class="matIcons" svgIcon="pdf" (click)="openPDFcustom('pdf')"
                     *ngIf="icon.name=='PDF'"></mat-icon>

                  <mat-icon class="matIcons" svgIcon="xls" (click)="excelExport()"
                     *ngIf="icon.name=='Excel'"></mat-icon>

                  <mat-icon class="matIcons" svgIcon="csv" (click)="excelExport()" *ngIf="icon.name=='CSV'"></mat-icon>
                  <mat-icon class="matIcons" svgIcon="png" (click)="exportToPNG()"
                     *ngIf="icon.name=='PNG' && !phiChecked"></mat-icon>

                  <div class="ml-3 icon_description_resp" *ngIf="icon.name=='Excel'">Export as CSV</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name=='PDF'">Export as PDF</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name=='PNG' && !phiChecked">Export as PNG</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='info_circle' && icon.activated">
                     Information
                  </div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='change_status' && icon.activated">Change
                     Status</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='expand_circle' && icon.activated">
                     {{isFullscreen ?
                     'Exit Full Screen' : 'Full Screen'}}</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='tabular_circle' && icon.activated">Show
                     Underlying
                     Data</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='union_circle' && icon.activated">User View
                  </div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='compare' && icon.activated">Compare</div>
                  <div class="ml-3 icon_description_resp" *ngIf="icon.name =='setting' && icon.activated">Settings</div>
                  <div class="ml-3 icon_description_resp"
                     *ngIf="icon.name =='gridload_circle' && expandChart && icon.activated">
                     Collapse All</div>
                  <div class="ml-3 icon_description_resp"
                     *ngIf="icon.name =='gridload_circle' && !expandChart && icon.activated">
                     Expand All</div>
               </div>
               <hr style="border: 1px solid rgba(0, 0, 0, 0.05);" />
            </div>
         </div>
      </div>
   </div>
</ng-template>


<mat-menu #info="matMenu" class="chart-info-menu">
   <div class="card" style="min-width: 300px;border: none;width: auto;" (click)="$event.stopPropagation()">
      <div class="card-header d-flex justify-content-between align-items-center"
         style="border-bottom: none;background: #ddd;">
         <span style="font-weight: 600;">{{infoData?.info_header || ''}}</span>
      
         <span (click)="closeMenu(info, $event)">
            <svg width="16" height="16" style="width: 12px !important;height: 12px !important;" viewBox="0 0 16 16"
               fill="none" xmlns="http://www.w3.org/2000/svg">
               <path
                  d="M12.9501 0.409871L8 5.35998L3.04989 0.409871C2.5034 -0.136624 1.61634 -0.136624 1.06985 0.409871L0.409871 1.06985C-0.136624 1.61634 -0.136624 2.5034 0.409871 3.04989L5.35998 8L0.409871 12.9501C-0.136624 13.4966 -0.136624 14.3837 0.409871 14.9302L1.06985 15.5901C1.61634 16.1366 2.5034 16.1366 3.04989 15.5901L8 10.64L12.9501 15.5901C13.4966 16.1366 14.3837 16.1366 14.9302 15.5901L15.5901 14.9302C16.1366 14.3837 16.1366 13.4966 15.5901 12.9501L10.64 8L15.5901 3.04989C16.1366 2.5034 16.1366 1.61634 15.5901 1.06985L14.9302 0.409871C14.3837 -0.136624 13.4966 -0.136624 12.9501 0.409871Z"
                  fill="#1363DF" />
            </svg>
         </span>
      </div>

      <div class="card-body">
         <div [innerHtml]="(infoData?.info_text) || '' "></div>
      </div>
   </div>
</mat-menu>

<ng-template #prompt style="height: 200px; width: auto;">

   <div class="d-flex justify-content-between align-items-center"
      style="background-color: #F6F8FB;border-radius: 10px;">
      <div class="px-3 py-2">
         <h2 style="font-weight: 500;font-family: 'Poppins';margin: 0 !important;">{{
            (filterService.showByHeader=='true') ? (filterService.showByKey=='N'? (item.config['report_heading']+'
            NDC'):(item.config['report_heading']+' Location')) : (
            this.SubHeading?this.SubHeading:item.config['report_heading'] ) }}</h2>
      </div>
      <div class="px-3 py-2" style="margin: 0 0 -5px 0px !important;">
         <mat-icon mat-dialog-close class="close-icon" style="color: rgba(138, 152, 171, 1);">close</mat-icon>
      </div>
   </div>

   <pivot-grid [dateFormat]="dateFormat" [data]="gridData" [item]="item" [columnDef]="columnDefs" pagination="false"
      [pivot]="pivot"></pivot-grid>
</ng-template>

<ng-template #controlPopup>
   <div class="d-flex justify-content-between align-items-center"
      style="background-color: #f6f8fb; border-radius: 10px;">
      <div class="px-3 py-2" style="display: flex; align-items: center;">
         <h2 style="font-weight: 600; font-family: 'Poppins'; margin: 0 !important;">
            Transaction Details
         </h2>
         <span style="margin: 0 14px;">|</span>
         <h4 style="font-weight: 600;font-family: 'Poppins';margin: 0 !important;padding: 0;">
            {{
            filterService.dragDate.length > 0
            ? moment(filterService.dragDate[0]).format('MMM DD, yyyy') +
            ' - ' +
            moment(filterService.dragDate[1]).format('MMM DD, yyyy')
            : moment(filterService.baseQuery.from_date).format('MMM DD, yyyy') +
            ' - ' +
            moment(filterService.baseQuery.to_date).format('MMM DD, yyyy')
            }}
         </h4>
      </div>
      <div class="px-3 py-2">
         <mat-icon mat-dialog-close class="close-icon"
            style="color: rgba(138, 152, 171, 1); cursor: pointer;">close</mat-icon>
      </div>
   </div>
   <!-- Loading Spinner -->
   <div mat-dialog-content *ngIf="!clicked"
      style="position: relative;height: 200px;width: 100%;display: flex;justify-content: center;align-items: center;background: white;border-radius: 8px;border-radius: 10px;">
      <app-progress-indefinite [height]="'50px'" [width]="'50px'"></app-progress-indefinite>
   </div>
   <!-- No Data Message -->
   <div mat-dialog-content *ngIf="clicked && gridData.length === 0"
      style="height: 200px;width: 100%;background: white;text-align: center;padding-top: 75px;font-family: 'Poppins';font-weight: 600;font-size: 19px;color: gray;border-radius: 10px;">
      There is no data for this time period
   </div>
   <!-- Pivot Grid -->
   <pivot-grid *ngIf="clicked && gridData.length > 0" [dateFormat]="dateFormat" [data]="gridData" [item]="item"
      [columnDef]="columnDefs" [pagination]="true" [pivot]="pivot"></pivot-grid>
</ng-template>


<ng-template #pdfCustom style="height: 100px; width: auto;">
   <div class="header" style="height: 40px;">
      <div class="row">
         <div class="col-9 text-start pl-2">
            <h2 class="pl-4 mt-1" style="font-family: 'Poppins'!important;">{{"PDF Position"}}</h2>
         </div>
         <div class="col-3 text-end pt-1">
            <mat-icon class="pr-5 mt-1" [mat-dialog-close]="true">close</mat-icon>
         </div>
      </div>
   </div>
   <div style="width:100%; text-align: center; padding: 10px;">
      <mat-radio-group aria-label="Select an option" [(ngModel)]="PdfPosition">
         <mat-radio-button value="l">Landscape </mat-radio-button>
         <mat-radio-button class="ml-5" value="p">Portrait </mat-radio-button>
      </mat-radio-group>
   </div>
   <div style="text-align: center; padding: 10px;">
      <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="onSaveChartClicked();">PDF
         Export</button>
   </div>
</ng-template>

<ng-template #SettingTemplate>

   <!-- Boundary keeps the popup inside the popup pane it is opened in; resolves to null (free
        dragging, as before) when the chart is not inside a dialog. -->
   <div class="popoverCustom" cdkDrag cdkDragRootElement=".popoverCustom" cdkDragHandle
      cdkDragBoundary=".cdk-overlay-pane">
      <div class="header all-scroll " style="height: 40px;margin: -12px;border-radius: 5px;">
         <div class="row">
            <div class="col-6 text-start pl-2" style="margin: 8px 10px;">
               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                     d="M13.6057 7.37666L9.77561 7.37666V8.62341H13.6057L12.1175 10.1116L13.0029 10.9971L16 8.00004L13.0029 5.00297L12.1175 5.88842L13.6057 7.37666Z"
                     fill="#8A98AB" />
                  <path
                     d="M8.62521 6.22626L8.62334 2.39428L10.1116 3.88252L10.997 2.99707L7.99996 0L5.0029 2.99707L5.88835 3.88252L7.37659 2.39428L7.37659 6.22439L8.62521 6.22626Z"
                     fill="#8A98AB" />
                  <path
                     d="M7.37666 9.77561L7.37666 13.6057L5.88842 12.1175L5.00297 13.0029L8.00004 16L10.9971 13.0029L10.1116 12.1175L8.62341 13.6057L8.62528 9.77374L7.37666 9.77561Z"
                     fill="#8A98AB" />
                  <path
                     d="M3.88252 5.88835L2.99707 5.0029L0 7.99996L2.99707 10.997L3.88252 10.1116L2.39428 8.62334L6.22626 8.62521V7.37472L2.39428 7.37659L3.88252 5.88835Z"
                     fill="#8A98AB" />
               </svg>
            </div>
            <div class="col-3 text-end pt-1 justify-content-between contect" style="display: flex; margin: 0 24px;">
               <h3>Settings</h3>
               <!-- <span class="pl-2 " style="margin-top: 4px;">
										<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
													d="M0.191807 6.4955L0.584883 6.8913C0.708591 7.01492 0.873178 7.08301 1.04908 7.08301C1.22489 7.08301 1.38967 7.01492 1.51338 6.8913L5.99732 2.40717L10.4864 6.89628C10.6099 7.01989 10.7747 7.08789 10.9505 7.08789C11.1263 7.08789 11.2912 7.01989 11.4148 6.89628L11.808 6.50291C12.064 6.2471 12.064 5.83042 11.808 5.57461L6.46317 0.210567C6.33966 0.087054 6.17507 2.84539e-05 5.99771 2.84694e-05L5.99566 2.84696e-05C5.81975 2.8485e-05 5.65517 0.0871516 5.53165 0.210567L0.191807 5.56007C0.0680982 5.68359 0.000194914 5.85315 -1.94455e-07 6.02896C-1.79077e-07 6.20486 0.0680983 6.37208 0.191807 6.4955Z"
													fill="#8A98AB" />
										</svg></span> -->

            </div>
         </div>
      </div>
      <!-- <form [formGroup]="userForm" (ngSubmit)="onSubmit(this.userForm.value)"> -->
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headS">Std deviation</span> <mat-slide-toggle class="togControl" [(ngModel)]="Stddeviation"
               style="float: right;"></mat-slide-toggle></div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headSub">{{'Lookback period (' + this.getPeriodtext()+')'}}</span> <input type="number"
               min="0" [(ngModel)]="look_back_period" #lookbackperiod
               (keydown)="restictnumberneg($event, lookbackperiod)" style="float: right; width: 70px; height: 30px;"
               class="form-control" [disabled]="!Stddeviation">
         </div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headSub">No Std deviations </span> <input type="number" min="0"
               [(ngModel)]="no_of_std_deviations" #noofstddeviations
               (keydown)="restictnumberneg($event, noofstddeviations)" style="float: right; width: 70px; height: 30px;"
               class="form-control" [disabled]="!Stddeviation"></div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headS">Thresholds values</span> <mat-slide-toggle class="togControl"
               [(ngModel)]="Thresholdsvalues" style="float: right;"></mat-slide-toggle></div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headSub">Upper thresholds</span> <input type="number" [(ngModel)]="upper_threshold"
               [min]="lower_threshold>0?lower_threshold:0" #upperthreshold
               (keydown)="restictnumberneg($event, upperthreshold)" style="float: right; width: 70px; height: 30px;"
               class="form-control" [disabled]="!Thresholdsvalues">
         </div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headSub">Lower thresholds</span> <input type="number" min="0" [max]="upper_threshold"
               [(ngModel)]="lower_threshold" #lowerthreshold (keydown)="restictnumberneg($event, lowerthreshold)"
               style="float: right; width: 70px; height: 30px;" class="form-control" [disabled]="!Thresholdsvalues">
         </div>
      </div>
      <div class="mt-3" style="text-align: left !important;">
         <div> <span class="headS">Mean (Avg)</span> <mat-slide-toggle class="togControl" [(ngModel)]="MeanAvg"
               style="float: right;"></mat-slide-toggle></div>
      </div>
      <!-- <div class="mt-3" style="text-align: left !important;">
					<div> <span class="headS">Buffer</span><mat-slide-toggle [(ngModel)]="Buffer"
							style="float: right;"></mat-slide-toggle> </div>
				</div>
				<div class="mt-3" style="text-align: left !important;">
					<div> <span class="headSub">Buffer range, %</span> 
							<input type="number"  min="0" max="100"  #inputText (keydown)="checkLength2($event, inputText)"  [(ngModel)]="buffer_range"   
								style="float: right; width: 70px; height: 30px;"  class="form-control"  [disabled]="!Buffer"></div>
				</div> -->
      <div class="mt-3 mb-2" style="text-align: left !important;">
         <div>
            <span class="headSub">
               <!-- <mat-checkbox class="example-margin" [(ngModel)]="checkedPreview" (change)="preview()">Preview</mat-checkbox> -->
               <button type="button" class="btn btn-preview" (click)="preview()">Preview</button>
            </span>
            <span class="headSub" style="float: right;"><button type="button" class="btn  btn-reset"
                  (click)="reset()">Reset</button></span>
            <!-- <div style="float: right; " (click)="reset()"><span style="margin-right: 4px;color: red;">Reset</span>
								<svg viewBox="260.084 137.146 16 16" width="16" height="16" xmlns="http://www.w3.org/2000/svg">
									<circle cx="268.084" cy="145.146" r="8" style="fill: rgb(255, 0, 0);" transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -2.842170943040401e-14, 0)"/>
									<path d="M 270.064 142.11 L 268.084 144.09 L 266.104 142.11 C 265.885 141.891 265.53 141.891 265.311 142.11 L 265.047 142.374 C 264.829 142.592 264.829 142.947 265.047 143.166 L 267.028 145.146 L 265.047 147.126 C 264.829 147.344 264.829 147.699 265.047 147.918 L 265.311 148.182 C 265.53 148.4 265.885 148.4 266.104 148.182 L 268.084 146.202 L 270.064 148.182 C 270.282 148.4 270.637 148.4 270.856 148.182 L 271.12 147.918 C 271.338 147.699 271.338 147.344 271.12 147.126 L 269.14 145.146 L 271.12 143.166 C 271.338 142.947 271.338 142.592 271.12 142.374 L 270.856 142.11 C 270.637 141.891 270.282 141.891 270.064 142.11 Z" fill="white" transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -2.842170943040401e-14, 0)"/>
									<path d="M 270.064 142.11 L 268.084 144.09 L 266.104 142.11 C 265.885 141.891 265.53 141.891 265.311 142.11 L 265.047 142.374 C 264.829 142.592 264.829 142.947 265.047 143.166 L 267.028 145.146 L 265.047 147.126 C 264.829 147.344 264.829 147.699 265.047 147.918 L 265.311 148.182 C 265.53 148.4 265.885 148.4 266.104 148.182 L 268.084 146.202 L 270.064 148.182 C 270.282 148.4 270.637 148.4 270.856 148.182 L 271.12 147.918 C 271.338 147.699 271.338 147.344 271.12 147.126 L 269.14 145.146 L 271.12 143.166 C 271.338 142.947 271.338 142.592 271.12 142.374 L 270.856 142.11 C 270.637 141.891 270.282 141.891 270.064 142.11 Z" fill="#8A98AB" transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -2.842170943040401e-14, 0)"/>
									<path d="M 270.064 142.11 L 268.084 144.09 L 266.104 142.11 C 265.885 141.891 265.53 141.891 265.311 142.11 L 265.047 142.374 C 264.829 142.592 264.829 142.947 265.047 143.166 L 267.028 145.146 L 265.047 147.126 C 264.829 147.344 264.829 147.699 265.047 147.918 L 265.311 148.182 C 265.53 148.4 265.885 148.4 266.104 148.182 L 268.084 146.202 L 270.064 148.182 C 270.282 148.4 270.637 148.4 270.856 148.182 L 271.12 147.918 C 271.338 147.699 271.338 147.344 271.12 147.126 L 269.14 145.146 L 271.12 143.166 C 271.338 142.947 271.338 142.592 271.12 142.374 L 270.856 142.11 C 270.637 141.891 270.282 141.891 270.064 142.11 Z" style="mix-blend-mode: overlay; fill-rule: evenodd; paint-order: fill; fill: rgb(252, 252, 252);" transform="matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -2.842170943040401e-14, 0)"/>
								</svg>
							</div> -->
         </div>
      </div>
      <hr>
      <div class=" text-right">
         <!-- <button type="button" class="btn btn-cancel" (click)="preview()">Preview</button> -->
         <button type="button" class="btn btn-cancel" style="line-height: 15px;" (click)="cancel()">Cancel</button>
         <button type="button" class="btn btn-primary" style="line-height: 15px;" (click)="Apply()">Apply</button>
         <!-- <button
					type="submit"
					[ngClass]="{'opacity-50': !userForm.valid }"
				
					[disabled]="!userForm.valid"
				>
					Submit
				</button> -->
      </div>
      <!-- </form> -->
   </div>
</ng-template>

<mat-menu #iPadMode="matMenu" class="menu-center">
   <div (click)="$event.stopPropagation()" *ngIf="this.deviceDetectionService.isTablet">
      <div>
         Chat Settings
         <br>
      </div>
      <div *ngFor="let hdr of headerConfig">
         <div *ngIf="hdr.add_header">
            <div *ngIf="hdr.slider">
               <span style="position: relative;">

                  <!-- <mat-form-field> -->
                  <mat-label class="matClassForRel">Activity Since</mat-label>
                  <mat-select>
                     <mat-option *ngFor="let ds of sliderArray" [value]="ds['value']">
                        {{ds['name']}}
                     </mat-option>
                  </mat-select>
                  <!-- </mat-form-field> -->

               </span>
            </div>
         </div>
      </div>
   </div>

</mat-menu>

<ng-template #customTemplate let-options="options">

   <div class="popoverCustom">

      <div class="mb-2">

         <span class="heading">Set moving average period</span>

      </div>

      <div class="input-group mb-3">

         <span class="input-group-text" (click)="decrement()"><mat-icon [svgIcon]="minus"
               class="addicon minusicon"></mat-icon></span>

         <input type="text" (keypress)="numberOnly($event)" [(ngModel)]="counter" maxlength="1"
            class="form-control counter">

         <span class="input-group-text" (click)="increment()"><mat-icon [svgIcon]="plus" class="addicon"></mat-icon>

         </span>

      </div>

      <div class="p-2 text-right">

         <button type="button" class="btn btn-cancel" (click)="movingavgs()">Cancel</button>

         <button type="button" class="btn btn-primary" (click)="countSave(customTemplate)">Apply</button>

      </div>

   </div>

</ng-template>

<!-- <ng-template #ExportToTablePDF>
   <app-pdf-export-popup 
     [columnDefs]="exportcolumnDefs"
     [rowData]="data" 
     [columnDefs2]="[]" 
     >
   </app-pdf-export-popup>
</ng-template> -->

<ng-template #progressBar>
   <div class="progress-overlay">
      <!-- In-progress state: bar + percentage -->
      <ng-container *ngIf="!exportError; else exportErrorState">
         <div class="progress-container">
            <div class="progress-bar" [style.width.%]="progress"></div>
         </div>
         <p>{{ progressLabel }}... {{ progress }}%</p>
      </ng-container>

      <!-- Error state: close icon + message -->
      <ng-template #exportErrorState>
         <button type="button"
                 class="export-error-close"
                 aria-label="Close"
                 (click)="closeExportDialog()">&times;</button>
         <div class="export-error-icon">!</div>
         <p class="export-error-text">{{ exportErrorMessage }}</p>
      </ng-template>
   </div>
</ng-template>